/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduleEntity } from './ScheduleEntity';
import {
    ScheduleEntityFromJSON,
    ScheduleEntityFromJSONTyped,
    ScheduleEntityToJSON,
    ScheduleEntityToJSONTyped,
} from './ScheduleEntity';

/**
 * Participant data
 * @export
 * @interface ScheduleParticipantEntity
 */
export interface ScheduleParticipantEntity {
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    id?: string;
    /**
     * 
     * @type {ScheduleEntity}
     * @memberof ScheduleParticipantEntity
     */
    schedule?: ScheduleEntity;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    participantType?: ScheduleParticipantEntityParticipantTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    resourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    role?: ScheduleParticipantEntityRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleParticipantEntity
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ScheduleParticipantEntity
     */
    orderIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    skills?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    availability?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    metadata?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleParticipantEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleParticipantEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleParticipantEntity
     */
    updatedBy?: string;
}


/**
 * @export
 */
export const ScheduleParticipantEntityParticipantTypeEnum = {
    User: 'USER',
    Team: 'TEAM',
    Resource: 'RESOURCE',
    External: 'EXTERNAL'
} as const;
export type ScheduleParticipantEntityParticipantTypeEnum = typeof ScheduleParticipantEntityParticipantTypeEnum[keyof typeof ScheduleParticipantEntityParticipantTypeEnum];

/**
 * @export
 */
export const ScheduleParticipantEntityRoleEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Observer: 'OBSERVER',
    Manager: 'MANAGER',
    Specialist: 'SPECIALIST'
} as const;
export type ScheduleParticipantEntityRoleEnum = typeof ScheduleParticipantEntityRoleEnum[keyof typeof ScheduleParticipantEntityRoleEnum];


/**
 * Check if a given object implements the ScheduleParticipantEntity interface.
 */
export function instanceOfScheduleParticipantEntity(value: object): value is ScheduleParticipantEntity {
    return true;
}

export function ScheduleParticipantEntityFromJSON(json: any): ScheduleParticipantEntity {
    return ScheduleParticipantEntityFromJSONTyped(json, false);
}

export function ScheduleParticipantEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleParticipantEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'schedule': json['schedule'] == null ? undefined : ScheduleEntityFromJSON(json['schedule']),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'participantType': json['participantType'] == null ? undefined : json['participantType'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'resourceId': json['resourceId'] == null ? undefined : json['resourceId'],
        'name': json['name'] == null ? undefined : json['name'],
        'role': json['role'] == null ? undefined : json['role'],
        'active': json['active'] == null ? undefined : json['active'],
        'orderIndex': json['orderIndex'] == null ? undefined : json['orderIndex'],
        'skills': json['skills'] == null ? undefined : json['skills'],
        'availability': json['availability'] == null ? undefined : json['availability'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
    };
}

export function ScheduleParticipantEntityToJSON(json: any): ScheduleParticipantEntity {
    return ScheduleParticipantEntityToJSONTyped(json, false);
}

export function ScheduleParticipantEntityToJSONTyped(value?: ScheduleParticipantEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'schedule': ScheduleEntityToJSON(value['schedule']),
        'tenantId': value['tenantId'],
        'participantType': value['participantType'],
        'userId': value['userId'],
        'teamId': value['teamId'],
        'resourceId': value['resourceId'],
        'name': value['name'],
        'role': value['role'],
        'active': value['active'],
        'orderIndex': value['orderIndex'],
        'skills': value['skills'],
        'availability': value['availability'],
        'metadata': value['metadata'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
    };
}

